import { memo, type HTMLAttributes } from "react";
import { twMerge } from "tailwind-merge";

const baseClasses = "rounded-lg border-primary/20 border-[1px] flex flex-col w-full p-8";

type BoxProps = HTMLAttributes<HTMLDivElement> & { card?: boolean; shadow?: boolean };

export const Box = memo(function Box({ className, card, ...props }: BoxProps) {
    return <div {...props} className={twMerge(baseClasses, card ? "bg-card" : "", className)} />;
});

Box.displayName = "Box";
